var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input flex relative"},[_vm._t("default"),_c('icon',{staticClass:"absolute w-4 h-4 text-black right-0 mr-3 center-y pointer-events-none",attrs:{"name":"chevron_down"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }